import { AccountUploadPathKey } from '../../../../../api/file-to-s3.dao';
import UploadImageS3VM, { IDefaultImage } from './upload-image-to-s3.viewmodel';

class AccountLevelUploadImageS3VM extends UploadImageS3VM {
    constructor(
        accountId: number,
        imageName: string,
        pathKey: AccountUploadPathKey,
        imageDescription?: string,
        defaultImage?: IDefaultImage,
        exceptSVG?: boolean,
    ) {
        super(accountId, null, imageName, pathKey, imageDescription, defaultImage, exceptSVG);
        this.uploadParams = { accountId: accountId };
    }
}

export { AccountLevelUploadImageS3VM };
